<template>
    <div class="examine-notice-detail">
        <div class="examin-notice-box">
            <div class="widthPC-90 margin-x-auto">
                <div class="fileNo text-right" v-if="baseInfo.fileNo">{{ baseInfo.fileNo }}</div>
                <div class="related-title">项目基础信息</div>
                <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
                    <tr>
                        <th colspan="4" class="py-2">{{ baseInfo.title }}</th>
                    </tr>
                    <tr>
                        <td class="font-bold">项目名称 ：</td>
                        <td>{{ baseInfo.projectName }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目编码 ：</td>
                        <td>{{ baseInfo.projectCode }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目业主名称 ：</td>
                        <td>{{ baseInfo.purchaserName || '-' }}</td>
                    </tr>
                    <!-- <tr>
                        <td class="font-bold">业主单位咨询电话 ：</td>
                        <td>{{ baseInfo.consultPhone || '-' }}</td>
                    </tr> -->
                    <tr>
                        <td class="font-bold">中选中介机构名称 ：</td>
                        <td>{{ baseInfo.bidAgentName || '-' }}</td>
                    </tr>
                    <!-- <tr>
                        <td class="font-bold">中介机构联系地址 ：</td>
                        <td>{{ notice.bidAgentOfficeAddress || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">服务内容 ：</td>
                        <td>{{ contact.serviceContent || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目规模 ：</td>
                        <td>{{ baseInfo.restrictions || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">服务金额 ：</td>
                        <td>
                            <span v-if="baseInfo.minServicePrice>0 || baseInfo.minServicePrice>0">{{ baseInfo.minServicePrice +' 至 ' + baseInfo.maxServicePrice || '-' }}</span>
                            <span v-else>-</span>
                        </td>
                    </tr> -->
                    <tr>
                        <td class="font-bold">合同金额 ：</td>
                        <td>{{ baseInfo.contractPrice || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">合同时间 ：</td>
                        <td>{{ baseInfo.contractDate || '-' }}</td>
                    </tr>
                    <!-- <tr>
                        <td class="font-bold">服务终止时间 ：</td>
                        <td>{{ baseInfo.terminationDate || '-' }}</td>
                    </tr> -->

                </table>
                
                <ad :type="1"></ad>

                <div>
                    <div class="related-title">项目业务流程</div>
                    <div class="process"> 
                            <div class="process-title" 
                                @click="handleProcessClick(list)" 
                                v-for="list in processList" 
                                :class="list.value == processValue ? 'active' : ''" 
                                :style="list.id?'':'backgroundColor:#fff;color:rgb(204 204 204);cursor:not-allowed;'"
                                :key="list.value">
                                 {{ list.label }}
                            </div> 
                    </div>
                    <div>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="tendingNotices && tendingNotices.id && processValue == 1">
                            <tr>
                                <th>标段名称</th>
                                <td colspan="3">{{ tendingNotices.bidSectionName }}</td>
                            </tr>
                            <tr>
                                <th>标段编码</th>
                                <td colspan="3">{{ tendingNotices.bidSectionNumber }}</td>
                            </tr>
                            <tr>
                                <th>分类</th>
                                <td colspan="3">{{ tendingNotices.classifyType }}</td>
                            </tr>
                            <!-- <tr>
                                <th>正文</th>
                                <td colspan="3">{{ tendingNotices.projectTypeName }}</td>
                            </tr> -->
                            <!-- <tr>
                                <th>城市</th>
                                <td>{{ tendingNotices.servicePrice }}</td>
                            </tr> -->
                            <tr>
                                <th>通知标题</th>
                                <td>{{ tendingNotices.noticeTitle }}</td>
                            </tr>
                            <!-- <tr>
                                <th>通知分类</th>
                                <td>{{ tendingNotices.bidSectionName || '-'}}</td>
                            </tr> -->
                            <tr>
                                <th>项目名称</th>
                                <td>{{ tendingNotices.projectName || '-'}}</td>
                            </tr>
                            <tr>
                                <th>项目区域</th>
                                <td>{{ tendingNotices.projectRegion }}</td>
                            </tr>
                            <tr>
                                <th>项目类型</th>
                                <td>{{ tendingNotices.projectType }}</td>
                            </tr>
                            <tr>
                                <th>招标代理企业统一社会信用代码</th>
                                <td>{{ tendingNotices.proxyComCode }}</td>
                            </tr>
                            <tr>
                                <th>招标代理企业名称</th>
                                <td>{{ tendingNotices.proxyComName }}</td>
                            </tr>
                            <tr>
                                <th>发布时间</th>
                                <td>{{ tendingNotices.publishTime }}</td>
                            </tr>
                            <!-- <tr>
                                <th>上级通知分类</th>
                                <td>{{ tendingNotices.bidtext }}</td>
                            </tr> -->
                            <tr>
                                <th>行政监督部门</th>
                                <td>{{ tendingNotices.superviseDept }}</td>
                            </tr>
                            <tr>
                                <th>招标项目名称</th>
                                <td>{{ tendingNotices.tenderProjectName }}</td>
                            </tr>
                            <tr>
                                <th>招标项目编码</th>
                                <td>{{ tendingNotices.tenderProjectNumber }}</td>
                            </tr>
                            <tr>
                                <th>招标人(建设单位)</th>
                                <td>{{ tendingNotices.tenderer }}</td>
                            </tr>

                            <tr>
                                <th>招标类型</th>
                                <td>{{ tendingNotices.tradeType }}</td>
                            </tr>
                            <tr>
                                <th>中标单位</th>
                                <td>{{ tendingNotices.winningBidder || '-' }}</td>
                            </tr>


                        </table>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="tendingResultNotices && tendingResultNotices.id  && processValue == 2">
                            <tr>
                                <th>标段名称</th>
                                <td colspan="3">{{ tendingResultNotices.bidSectionName }}</td>
                            </tr>
                            <tr>
                                <th>标段编码</th>
                                <td colspan="3">{{ tendingResultNotices.bidSectionNumber }}</td>
                            </tr>
                            <tr>
                                <th>分类</th>
                                <td colspan="3">{{ tendingResultNotices.classifyType }}</td>
                            </tr>
                            <!-- <tr>
                                <th>正文</th>
                                <td colspan="3">{{ tendingResultNotices.projectTypeName }}</td>
                            </tr> -->
                            <!-- <tr>
                                <th>城市</th>
                                <td>{{ tendingResultNotices.servicePrice }}</td>
                            </tr> -->
                            <tr>
                                <th>通知标题</th>
                                <td>{{ tendingResultNotices.noticeTitle }}</td>
                            </tr>
                            <!-- <tr>
                                <th>通知分类</th>
                                <td>{{ tendingResultNotices.bidSectionName || '-'}}</td>
                            </tr> -->
                            <tr>
                                <th>项目名称</th>
                                <td>{{ tendingResultNotices.projectName || '-'}}</td>
                            </tr>
                            <tr>
                                <th>项目区域</th>
                                <td>{{ tendingResultNotices.projectRegion }}</td>
                            </tr>
                            <tr>
                                <th>项目类型</th>
                                <td>{{ tendingResultNotices.projectType }}</td>
                            </tr>
                            <tr>
                                <th>招标代理企业统一社会信用代码</th>
                                <td>{{ tendingResultNotices.proxyComCode }}</td>
                            </tr>
                            <tr>
                                <th>招标代理企业名称</th>
                                <td>{{ tendingResultNotices.proxyComName }}</td>
                            </tr>
                            <tr>
                                <th>发布时间</th>
                                <td>{{ tendingResultNotices.publishTime }}</td>
                            </tr>
                            <!-- <tr>
                                <th>上级通知分类</th>
                                <td>{{ tendingResultNotices.bidtext }}</td>
                            </tr> -->
                            <tr>
                                <th>行政监督部门</th>
                                <td>{{ tendingResultNotices.superviseDept }}</td>
                            </tr>
                            <tr>
                                <th>招标项目名称</th>
                                <td>{{ tendingResultNotices.tenderProjectName }}</td>
                            </tr>
                            <tr>
                                <th>招标项目编码</th>
                                <td>{{ tendingResultNotices.tenderProjectNumber }}</td>
                            </tr>
                            <tr>
                                <th>招标人(建设单位)</th>
                                <td>{{ tendingResultNotices.tenderer }}</td>
                            </tr>

                            <tr>
                                <th>招标类型</th>
                                <td>{{ tendingResultNotices.tradeType }}</td>
                            </tr>
                            <tr>
                                <th>中标单位</th>
                                <td>{{ tendingResultNotices.winningBidder || '-' }}</td>
                            </tr>
                            <tr>
                                <th>中标总金额(单位万)</th>
                                <td>{{ tendingResultNotices.bidPrice || '-' }}</td>
                            </tr>
                            

                        </table>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="contactNotices && contactNotices.id  && processValue == 3">
                            <tr>
                                <th>标段名称</th>
                                <td colspan="3">{{ contactNotices.bidSectionName }}</td>
                            </tr>
                            <tr>
                                <th>标段编码</th>
                                <td colspan="3">{{ contactNotices.bidSectionNumber }}</td>
                            </tr>
                            <tr>
                                <th>分类</th>
                                <td colspan="3">{{ contactNotices.classifyType }}</td>
                            </tr>
                            <!-- <tr>
                                <th>正文</th>
                                <td colspan="3">{{ contactNotices.projectTypeName }}</td>
                            </tr> -->
                            <!-- <tr>
                                <th>城市</th>
                                <td>{{ contactNotices.servicePrice }}</td>
                            </tr> -->
                            <tr>
                                <th>通知标题</th>
                                <td>{{ contactNotices.noticeTitle }}</td>
                            </tr>
                            <!-- <tr>
                                <th>通知分类</th>
                                <td>{{ contactNotices.bidSectionName || '-'}}</td>
                            </tr> -->
                            <tr>
                                <th>项目名称</th>
                                <td>{{ contactNotices.projectName || '-'}}</td>
                            </tr>
                            <tr>
                                <th>项目区域</th>
                                <td>{{ contactNotices.projectRegion }}</td>
                            </tr>
                            <tr>
                                <th>项目类型</th>
                                <td>{{ contactNotices.projectType }}</td>
                            </tr>
                            <tr>
                                <th>招标代理企业统一社会信用代码</th>
                                <td>{{ contactNotices.proxyComCode }}</td>
                            </tr>
                            <tr>
                                <th>招标代理企业名称</th>
                                <td>{{ contactNotices.proxyComName }}</td>
                            </tr>
                            <tr>
                                <th>发布时间</th>
                                <td>{{ contactNotices.publishTime }}</td>
                            </tr>
                            <!-- <tr>
                                <th>上级通知分类</th>
                                <td>{{ contactNotices.bidtext }}</td>
                            </tr> -->
                            <tr>
                                <th>行政监督部门</th>
                                <td>{{ contactNotices.superviseDept }}</td>
                            </tr>
                            <tr>
                                <th>招标项目名称</th>
                                <td>{{ contactNotices.tenderProjectName }}</td>
                            </tr>
                            <tr>
                                <th>招标项目编码</th>
                                <td>{{ contactNotices.tenderProjectNumber }}</td>
                            </tr>
                            <tr>
                                <th>招标人(建设单位)</th>
                                <td>{{ contactNotices.tenderer }}</td>
                            </tr>

                            <tr>
                                <th>招标类型</th>
                                <td>{{ contactNotices.tradeType }}</td>
                            </tr>
                            <tr>
                                <th>中标单位</th>
                                <td>{{ contactNotices.winningBidder || '-' }}</td>
                            </tr>
                            <tr>
                                <th>中标总金额(单位万)</th>
                                <td>{{ contactNotices.bidPrice || '-' }}</td>
                            </tr>
                            
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },
    data() {
        return {
            id: this.$route.query.id || null,
            baseInfo: {},
            processList: [
                { label: '招标公示', value: 1,type:'tendingNotices',id:null },
                { label: '招标结果公示', value: 2,type:'tendingResultNotices',id:null },
                { label: '合同公示', value: 3,type:'contactNotices',id:null },
            ],
            processValue: 1,
            tendingNotices: {},
            tendingResultNotices: {},
            contactNotices: {},
        }
    },
    created() {

    },
    mounted() {
        this.getData();
    },
    methods: {
        handleProcessClick(item) {
            if (!item.id) {
                // this.$message.warning('暂无数据');
                return;
            }
            this.processValue = item.value;
        },
        getData() {
            let ajaxUrl = this.$api.common.agencyService.DetailSZ() + '?id=' + this.id;
            this.$axios.get(ajaxUrl).then((res) => {
                console.log('数据详情', res);
                this.baseInfo = res.data.baseInfo || {};
                this.tendingNotices = (res.data.tendingNotices && res.data.tendingNotices[0]) || {};
                this.tendingResultNotices = (res.data.tendingResultNotices&& res.data.tendingResultNotices[0]) || {};
                this.contactNotices =  (res.data.contactNotices && res.data.contactNotices[0]) || {};

                 // ★ 核心代码：将对应对象的 id 传入 processList
            this.processList.forEach(item => {
                // this[item.type] 相当于 this.tendingNotices, this.tendingResultNotices 等
                const targetData = this[item.type]; 
                // 如果有数据且有 id 就赋值，否则给 null
                item.id = (targetData && targetData.id) ? targetData.id : null;
            });
            }).catch((err) => { });

        }
    }
}
</script>

<style lang="less" scoped> 

.detail-table.related-table{
    th,td{
        padding: 25px  10px;
    }
    th{
        background: #f1f8ff;
        width: 280px;
        min-width: 80px;
    }
    td{
        min-width: 220px;
        border: 1px solid #d6d6d6;
    }
}
.process {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #e6e6e6;
    border-radius: 5px;
    box-shadow: 0 2px 4px #ebf1f5;
    .process-title {
        width: calc(100%/5);
        font-size: 16px;
        color: #333;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-right: 1px solid #fff;
        font-weight: bold;
        &:hover,
        &.active {
            cursor: pointer;
            background-color: #2c5282;
            color: #ffffff;
        }
    }
} 

.examin-notice-box {
    padding: 20px;
    width: 100%;
    background: #fff;
}

.fileNo {
    font-size: 20px;
    color: #666;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
        text-align: center;
    }

    th,
    td {
        padding: 15px 10px;
        border: 1px solid #eee;
        min-width: 150px;
    }
}

.detail-content {
    margin-top: 20px;
    padding: 10px;
    line-height: 3;
    border: 1px solid #ebf1f5;
    box-shadow: 0 2px 4px #ebf1f5;
}
</style>